import React from 'react'
import PropTypes from 'prop-types'
import FacilityProfileV2 from 'model/facilities/facilityProfileV2'
import { FACILITIES_PATH } from 'constants/routes'

import { Row, Image, MainInfo, Data, Name, NameWrap } from 'ui/entities/styled'
import EntityTypes from 'components/EntityTypes'
import EntityVerified from 'components/EntityVerified'
import EntitySelectButtons from 'components/EntitySelectButtons'
import facility_default from 'assets/facility_default.png'
import EntityAddress from 'components/EntityAddress'
import { isNilOrEmpty } from 'utils/helpers'
import FacilityTier from './FacilityItem/FacilityTier'

const FacilityItem = ({
  facility,
  index = 0,
  isSelectionMode = false,
  addButtonText = false,
  isSelected = false,
  onSelectEntity = () => {},
  onRemoveEntity = () => {}
}) => (
  <Row data-test="facilityCard">
    <Image>
      <img
        src={
          isNilOrEmpty(facility.image_url)
            ? facility_default
            : facility.image_url
        }
        alt="facility"
        onError={({ currentTarget }) => {
          currentTarget.onerror = null // prevents looping
          currentTarget.src = facility_default
        }}
      />
    </Image>
    <MainInfo>
      <NameWrap>
        <Name href={`${FACILITIES_PATH}/${facility.id}`}>
          {index > 0 ? `${index}. ` : ''}
          {facility.name}
        </Name>
        <EntityVerified entity={facility} />
        <FacilityTier facility={facility} />
      </NameWrap>
      <EntityTypes
        entity={facility}
        sourceField="display_location_types"
        isBsmh={facility?.source === 'bsmh'}
      />
      {isSelectionMode && <EntityAddress entity={facility} isColumn />}
    </MainInfo>
    <Data>
      {isSelectionMode ? (
        <EntitySelectButtons
          entity={facility}
          addText={addButtonText}
          isSelected={isSelected}
          onSelectEntity={onSelectEntity}
          onRemoveEntity={onRemoveEntity}
        />
      ) : (
        <EntityAddress entity={facility} />
      )}
    </Data>
  </Row>
)

FacilityItem.propTypes = {
  index: PropTypes.number,
  facility: PropTypes.instanceOf(FacilityProfileV2).isRequired,
  isSelectionMode: PropTypes.bool,
  addButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isSelected: PropTypes.bool,
  onSelectEntity: PropTypes.func,
  onRemoveEntity: PropTypes.func
}

export default FacilityItem
